var _defs, _rect, _g, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478.93 566.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #7c787f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 0,
    width: 479,
    height: 567,
    rx: 106.32,
    ry: 106.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.44,132.26c0-8.52,5.54-14.23,14.23-14.23s14.27,5.71,14.27,14.23v89.11h47.58c8.18,0,14.78,4.17,14.78,12.01s-6.6,11.97-14.78,11.97h-59.42c-10.05,0-16.65-4-16.65-16.7v-96.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.59,132.26c0-8.52,5.54-14.23,14.23-14.23s14.27,5.71,14.27,14.23v101.12c0,8.48-5.58,14.23-14.27,14.23s-14.23-5.75-14.23-14.23v-101.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.38,237.73c-2.94,8.14-8.52,9.88-17.38,9.88s-14.4-1.75-17.38-9.88l-35.1-98.69c-1.19-3.28-1.7-6.09-1.7-8.35,0-9.54,7.28-12.65,14.4-12.65,7.67,0,11.84,4,14.44,12.48l25.68,85.15h.34l26.75-85.15c2.64-8.48,6.77-12.48,13.37-12.48,7.16,0,14.44,3.11,14.44,12.65,0,2.26-.51,5.07-1.75,8.35l-36.12,98.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.71,136.95c0-12.65,6.6-16.65,16.7-16.65h66.87c8.35,0,14.4,2.43,14.4,11.46s-6.05,11.46-14.4,11.46h-55.08v27.09h48.3c7.45,0,13.37,2.09,13.37,10.95s-5.92,10.95-13.37,10.95h-48.3v30.24h56.44c8.35,0,14.44,2.43,14.44,11.46s-6.09,11.46-14.44,11.46h-68.24c-10.1,0-16.7-4-16.7-16.7v-91.71Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.16,420.28c11.33-17.42,53-62.25,87.56-85.54,1.47-.99,3.13.95,1.91,2.24-32.83,34.67-67.92,73.89-88.08,107.8-.56.94-1.92.98-2.5.05-10.14-16.06-18.84-39.16-37.48-46.23-1.39-.53-1.25-2.48.19-2.83,17.87-4.3,26.24,10.98,38.41,24.52h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 174.05,
    y: 430.73,
    width: 218.09,
    height: 10.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/Live_icon.46088505791a750b049cb711342ed915.svg";
export { ForwardRef as ReactComponent };